import { RouteConfig } from 'vue-router';

const router: RouteConfig[] = [
  { path: '/login', name: 'Login', component: () => import('@/views/mine/Login.vue') },
  { path: '/notfound', name: '/notfound', component: () => import('@/views/ErrorPage.vue') }
];

const publicRouter = router.map(
  r =>
    <RouteConfig>{
      path: r.path,
      name: r.name,
      meta: {
        public: true
      },
      component: r.component
    }
);

export default publicRouter;
